import { History } from "history";

import {
  CalendarEventDto,
  CreateCalendarEventRequest,
  DateRangeQuery,
  PaginateQuery,
  UpdateCalendarEventRequest,
} from "../../interfaces";
import { Paginated } from "../../models";

//#region Get Calendar Events

export const GET_CALENDAR_EVENTS = "GET_CALENDAR_EVENTS";
export const GET_CALENDAR_EVENTS_SUCCESS: any = "GET_CALENDAR_EVENTS_SUCCESS";
export const GET_CALENDAR_EVENTS_ERROR: any = "GET_CALENDAR_EVENTS_ERROR";

export interface GetCalendarEventsAction {
  type: typeof GET_CALENDAR_EVENTS;
  payload: {
    request: PaginateQuery;
    history: History;
  };
}

export interface GetCalendarEventsSuccessAction {
  type: typeof GET_CALENDAR_EVENTS_SUCCESS;
  payload: Paginated<CalendarEventDto>;
}

export interface GetCalendarEventsErrorAction {
  type: typeof GET_CALENDAR_EVENTS_ERROR;
  payload: any;
}
//#endregion

//#region Get Calendar Events Between Dates

export const GET_ALL_CALENDAR_EVENTS = "GET_ALL_CALENDAR_EVENTS";
export const GET_ALL_CALENDAR_EVENTS_SUCCESS: any =
  "GET_ALL_CALENDAR_EVENTS_SUCCESS";
export const GET_ALL_CALENDAR_EVENTS_ERROR: any =
  "GET_ALL_CALENDAR_EVENTS_ERROR";

export interface GetAllCalendarEventsAction {
  type: typeof GET_ALL_CALENDAR_EVENTS;
  payload: {
    history: History;
  };
}

export interface GetAllCalendarEventsSuccessAction {
  type: typeof GET_ALL_CALENDAR_EVENTS_SUCCESS;
  payload: CalendarEventDto[];
}

export interface GetAllCalendarEventsErrorAction {
  type: typeof GET_ALL_CALENDAR_EVENTS_ERROR;
  payload: any;
}
//#endregion

//#region Get Calendar Event

export const GET_CALENDAR_EVENT = "GET_CALENDAR_EVENT";
export const GET_CALENDAR_EVENT_SUCCESS: any = "GET_CALENDAR_EVENT_SUCCESS";
export const GET_CALENDAR_EVENT_ERROR: any = "GET_CALENDAR_EVENT_ERROR";

export interface GetCalendarEventAction {
  type: typeof GET_CALENDAR_EVENT;
  payload: {
    id: string;
    history: History;
  };
}

export interface GetCalendarEventSuccessAction {
  type: typeof GET_CALENDAR_EVENT_SUCCESS;
  payload: CalendarEventDto;
}

export interface GetCalendarEventErrorAction {
  type: typeof GET_CALENDAR_EVENT_ERROR;
  payload: any;
}
//#endregion

//#region Add Calendar Event

export const ADD_CALENDAR_EVENT = "ADD_CALENDAR_EVENT";
export const ADD_CALENDAR_EVENT_SUCCESS: any = "ADD_CALENDAR_EVENT_SUCCESS";
export const ADD_CALENDAR_EVENT_ERROR: any = "ADD_CALENDAR_EVENT_ERROR";

export interface AddCalendarEventAction {
  type: typeof ADD_CALENDAR_EVENT;
  payload: {
    request: CreateCalendarEventRequest;
    history: History;
  };
}

export interface AddCalendarEventSuccessAction {
  type: typeof ADD_CALENDAR_EVENT_SUCCESS;
  payload: CalendarEventDto;
}

export interface AddCalendarEventErrorAction {
  type: typeof ADD_CALENDAR_EVENT_ERROR;
  payload: any;
}
//#endregion

//#region Update Calendar Event

export const UPDATE_CALENDAR_EVENT = "UPDATE_CALENDAR_EVENT";
export const UPDATE_CALENDAR_EVENT_SUCCESS: any =
  "UPDATE_CALENDAR_EVENT_SUCCESS";
export const UPDATE_CALENDAR_EVENT_ERROR: any = "UPDATE_CALENDAR_EVENT_ERROR";

export interface UpdateCalendarEventAction {
  type: typeof UPDATE_CALENDAR_EVENT;
  payload: {
    id: string;
    request: UpdateCalendarEventRequest;
    history: History;
  };
}

export interface UpdateCalendarEventSuccessAction {
  type: typeof UPDATE_CALENDAR_EVENT_SUCCESS;
  payload: CalendarEventDto;
}

export interface UpdateCalendarEventErrorAction {
  type: typeof UPDATE_CALENDAR_EVENT_ERROR;
  payload: any;
}
//#endregion

//#region Delete Calendar Event

export const DELETE_CALENDAR_EVENT_CONSENT: any =
  "DELETE_CALENDAR_EVENT_CONSENT";
export const DELETE_CALENDAR_EVENT = "DELETE_CALENDAR_EVENT";
export const DELETE_CALENDAR_EVENT_SUCCESS: any =
  "DELETE_CALENDAR_EVENT_SUCCESS";
export const DELETE_CALENDAR_EVENT_ERROR: any = "DELETE_CALENDAR_EVENT_ERROR";

export interface DeleteCalendarEventConsentAction {
  type: typeof DELETE_CALENDAR_EVENT_CONSENT;
  payload: string;
}

export interface DeleteCalendarEventAction {
  type: typeof DELETE_CALENDAR_EVENT;
  payload: {
    id: string;
    history: History;
  };
}

export interface DeleteCalendarEventSuccessAction {
  type: typeof DELETE_CALENDAR_EVENT_SUCCESS;
  payload: string;
}

export interface DeleteCalendarEventErrorAction {
  type: typeof DELETE_CALENDAR_EVENT_ERROR;
  payload: any;
}
//#endregion

// Export a union type that represents all possible actions
export type ActionTypes =
  | GetCalendarEventsAction
  | GetCalendarEventsSuccessAction
  | GetCalendarEventsErrorAction
  | GetCalendarEventAction
  | GetCalendarEventSuccessAction
  | GetCalendarEventErrorAction
  | AddCalendarEventAction
  | AddCalendarEventSuccessAction
  | AddCalendarEventErrorAction
  | UpdateCalendarEventAction
  | UpdateCalendarEventSuccessAction
  | UpdateCalendarEventErrorAction
  | DeleteCalendarEventConsentAction
  | DeleteCalendarEventAction
  | DeleteCalendarEventSuccessAction
  | DeleteCalendarEventErrorAction
  | GetAllCalendarEventsAction
  | GetAllCalendarEventsSuccessAction
  | GetAllCalendarEventsErrorAction;
